<div class="order-confirmation-mark">
    <div class="order-confirmation-mark__inner"></div>
    <div class="order-confirmation-mark__outer"></div>
    <shared-icon [icon]="icon" class="order-confirmation-mark__icon"></shared-icon>
</div>